import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { getStores } from 'features/product-info';

export const DATA_QA_STOCK_IN_STORES_HIDDEN = 'stock-in-stores-hidden';

export function StocksInStoresHidden() {
  const { t } = useTranslation();
  const stores = useSelector(getStores);
  const count = t('product-info.stocks.in-stores.count-modal', {
    stock: 1,
    unit: t('product-info.stocks.unit'),
  });

  if (!stores) return null;

  return (
    <div hidden data-qa={DATA_QA_STOCK_IN_STORES_HIDDEN}>
      {Object.entries(stores).map(([id, { address, name }]) => {
        return (
          <div key={id}>
            <p>{name}</p>
            <p>{address}</p>
            <p>{count}</p>
          </div>
        );
      })}
    </div>
  );
}
